// Public
export const LOGIN = '/login';
// Private
export const PRIVATE = '/private';
export const LOGOUT = PRIVATE + '/logout';
// Private User
export const PRIVATE_USER = PRIVATE + '/user';
export const PRIVATE_USER_PLAYERS = PRIVATE_USER + '/players';
export const PRIVATE_USER_CHANNELS = PRIVATE_USER + '/channels';
// Private Admin
export const PRIVATE_ADMIN = PRIVATE + '/admin';
export const PRIVATE_ADMIN_PLAYERS = PRIVATE_ADMIN + '/players';
export const PRIVATE_ADMIN_USERS = PRIVATE_ADMIN + '/users';
export const PRIVATE_ADMIN_M3US = PRIVATE_ADMIN + '/m3us';
export const PRIVATE_ADMIN_PLAYER_HEALTH = PRIVATE_ADMIN + '/player-health';
